module.exports = __webpack_public_path__ + "img/ff92d28.svg";